import React from "react";
import {
  Card,
  Tabs,
  Tab,
  Grid,
  Typography,
  FormControl,
  Select,
  MenuItem,
  CardContent,
  Divider,
  Button,
  IconButton,
  Radio,
  CircularProgress,
} from "@material-ui/core";
import TabContext from "@material-ui/lab/TabContext";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import TabPanel from "@material-ui/lab/TabPanel";
import ReactSelect from "react-select";
import PhoneIcon from "@material-ui/icons/Phone";
import { GrFormNextLink } from "react-icons/gr";
import { BiRefresh } from "react-icons/bi";
import { useStyles } from "./style";
import "./style.css";
// import UserNumberServices from '../../../userNumbersServices/usersNumbersServices'
// import UserNumberServices from '../../../../UsersNumbers/userNumbersServices/usersNumbersServices'
import CountryStates from "../CountryStates/CountryStates";
import { useSelector } from "react-redux";
import { $CombinedState } from "redux";
// import logo from '../../../../../assets/images/Lodingg.gif'
import "./style";
import CountryAreaCode from "../CountryStates/CountryAreaCode";

function AreaCode(props: any) {
  const classes = useStyles();
  const [value, setValue] = React.useState("1");
  const [index, setIndex] = React.useState("0");
  const [addData, setAddData] = React.useState<any>({
    phoneNumber: "",
  });


  const [currentData, setCurrentdata] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState<any>(null);
  const noofElements = 12;
  const paginate = (page: number) => {
    const startIndex = Math.floor(page * noofElements);
    const endindex = (page + 1) * noofElements;
    const splitData = currentData.slice(startIndex, endindex);
    setData([...splitData]);
  };
  const [id, setId] = React.useState<any>();

  const handleNumber = (id: any) => {
    setId(id);
    props.handleSelectedNumber(id);
  };

  React.useEffect(() => {
    paginate(currentPage);
  }, [currentPage, currentData]);

  React.useEffect(() => {
    console.log(props.localNumbers);
    setCurrentdata(props.localNumbers);
    setCurrentPage(0);
    //setData([])
  }, [props.localNumbers, props.localNumbers?.length]);

  return (
    <div>
      {props?.reserveNumber ? (
        ""
      ) : (
        <div>
          <CountryAreaCode
            onChangeAreaCode={props.onChangeAreaCode}
            onSearchAreaCodeBtnClicked={props.onSearchAreaCodeBtnClicked}
            countryOptions={props.countryOptions}
            country={props.country}
            areaCode={props.areaCode}
            onChangeCountryType={props.onChangeCountryType}
          />
          <div>
            {props.loading ? (
              <div
                style={{
                 marginTop:"1rem",
                  alignItems: "center",
                  color: "lightgray",
                  textAlign: "center",
                  width: "100%",
                  height: "80px",
                }}
              >
                <CircularProgress style={{ color: "red" }} />
              </div>
            ) : (
              <Grid
                container
                className="reserveinnerholder"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Grid item md={1}>
                  {data?.length > 0 && currentPage !== 0 ? (
                    <Button size="small" style={{}}>
                      <div
                        onClick={() => {
                          setCurrentPage(currentPage - 1);
                        }}
                        style={{
                          width: 45,
                          height: 45,
                          background: "#4D72F8",
                          display: "grid",
                          justifyContent: "center",
                          borderRadius: "50%",
                          color: "white",
                          alignItems: "center",
                        }}
                      >
                        <BiChevronLeft fontSize={25} />
                      </div>
                    </Button>
                  ) : (
                    " "
                  )}
                </Grid>
                <Grid container md={10} lg={10} xl={8}>
                  <ul
                    style={{
                      textDecoration: "none",
                      listStyleType: "none",
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {data?.length > 0 ? (
                      data.map((loc: any, i: any) => {
                        return (
                          <Grid item md={5} lg={4} xl={4}>
                           

                            <Button
                              key={i}
                              className={
                                id === loc.id
                                  ? classes.numberButtonActive
                                  : classes.numberButton
                              }
                              variant="outlined"
                              size="small"
                              fullWidth
                              onClick={() => handleNumber(loc?.id)}
                              // startIcon={<Radio />}
                            >
                              {loc?.didSummary}
                            </Button>
                          </Grid>
                        );
                      })
                    ) : (
                      <Typography
                        className={classes.choose}
                        style={{
                          marginLeft: 150,
                          textAlign: "center",
                          padding: "0px",
                          color: "white",
                        }}
                      >
                        Choose Options
                      </Typography>
                    )}
                  </ul>
                </Grid>

                <Grid item md={1}>
                  <Button size="small" style={{ float: "right" }}>
                    <div
                      onClick={() => {
                        setCurrentPage(currentPage + 1);
                      }}
                      style={{
                        width: 45,
                        height: 45,
                        background: "#fff",
                        display: "grid",
                        justifyContent: "center",
                        borderRadius: "50%",
                        color: "#0B1B37",
                        alignItems: "center",
                      }}
                    >
                      <BiChevronRight fontSize={25} />
                    </div>
                  </Button>
                </Grid>
              </Grid>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AreaCode;

